/**
 * Format a number with thousand separators.
 *
 * @param {number} value - The number to format
 * @param {Object} [options]
 * @param {number} [options.decimals=0] - Decimal places
 * @param {string} [options.separator=","] - Thousands separator character
 * @returns {string} Formatted number string
 */
export function formatNumber(value, { decimals = 0, separator = "," } = {}) {
  const fixed = value.toFixed(decimals)
  const parts = fixed.split(".")
  const integerPart = parts[0]
  const decimalPart = parts[1]

  const withSeparators = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    separator
  )

  if (decimals > 0 && decimalPart) {
    return `${withSeparators}.${decimalPart}`
  }

  return withSeparators
}

/**
 * Format bytes into a human-readable file size string.
 *
 * @param {number} bytes
 * @param {number} [decimals=1] - Decimal places
 * @returns {string} e.g. "1.5 MB"
 */
export function formatFileSize(bytes, decimals = 1) {
  if (bytes === 0) return "0 Bytes"

  const k = 1024
  const sizes = ["Bytes", "KB", "MB", "GB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const index = Math.min(i, sizes.length - 1)

  return `${parseFloat((bytes / Math.pow(k, index)).toFixed(decimals))} ${sizes[index]}`
}
